import axios from "axios";

export default axios.create({
  baseURL: "https://api.appforup.it/api/",
  responseType: "json"
});